import React, { useState } from 'react';

/**
 * User avatar with SkillSync logo icon as the default placeholder
 * (per V3 branding directive).
 */
export const UserAvatar = ({ src, alt = '', size = 32, rounded = 12, className = '', testId }) => {
  const [err, setErr] = useState(false);
  const show = !!src && !err;
  return (
    <span
      className={`shrink-0 overflow-hidden border border-white/15 bg-white/[0.08] flex items-center justify-center ${className}`}
      style={{ width: size, height: size, borderRadius: rounded }}
      data-testid={testId}
    >
      {show ? (
        <img src={src} alt={alt} onError={() => setErr(true)} className="w-full h-full object-cover" />
      ) : (
        <img src="/logo-icon.png" alt="" className="w-[72%] h-[72%] object-contain" draggable={false} />
      )}
    </span>
  );
};
